<template>
  <Modal
    v-model="_value"
    width="500"
    title="设置超速报警预警差值"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <Form :model="reqParams" :label-width="80">
      <FormItem prop="terminalNum" label="主机号">
        <Input v-model="reqParams.terminalNum" placeholder="请输入主机号">
        </Input>
      </FormItem>
      <FormItem prop="overSpeedAlarmDifference" label="超速报警预警差值">
        <Input v-model="reqParams.overSpeedAlarmDifference" placeholder="请输入超速报警预警差值">
        </Input>
        <label>Km/h</label>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setoverspeedalarmdifferencemodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    data() {
      return {
        reqParams: {
          terminalNum:'',
          overSpeedAlarmDifference:0
        }
      }
    },
    methods: {
      ...mapActions([
        'NetCommandServ_SetOverSpeedAlarmDifference'
      ]),
      onOk() {
        this.reqParams.overSpeedAlarmDifference = this.reqParams.overSpeedAlarmDifference*10
        store.dispatch('NetCommandServ_SetOverSpeedAlarmDifference', {
          params: this.reqParams
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.reqParams.terminalNum = this._initValue
          this.reqParams.overSpeedAlarmDifference = 14400
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
